
import CommonProfile from '@/components/common/CommonProfile.vue';
import CommonRating from '@/components/common/CommonRating.vue';

export default {
  name: 'ProfileAndRating',
  components: { CommonRating, CommonProfile },
  props: {
    teacherName: { type: String, default: null },
    teacherProfileImage: { type: String, default: null },
    reviewRating: { type: Number, default: 0 },
    reviewCount: { type: Number, default: 0 },
  },
};
